import { token } from '@cp/shared/di';
import { ClientRegistrationState } from '@common/model/client/registration/registrationState';
import { AsyncResult } from '@cp/shared/result';

export const LOGIN_FEATURE_TOKEN =
  token<(clientSelection?: Partial<ClientRegistrationState>) => AsyncResult<unknown, Error>>('Login feature');
